module.exports = __webpack_public_path__ + "img/flag.bed2a709.svg";